const $e463bdc3eb55f472$export$d155b7b3d8e33c99 = {
    students: {
        gamemode: 'Students',
        imgSubfolder: 'students',
        question: 'Who is this student?',
        urlAdress: 'https://hp-api.onrender.com/api/characters',
        filterKey: 'hogwartsStudent',
        filterValue: true,
        ids: 28,
        answerProperty: 'name'
    },
    staff: {
        gamemode: 'Staff',
        imgSubfolder: 'staff',
        question: 'Who is this staff?',
        urlAdress: 'https://hp-api.onrender.com/api/characters',
        filterKey: 'hogwartsStaff',
        filterValue: true,
        ids: 20,
        answerProperty: 'name'
    },
    houses: {
        gamemode: 'Houses',
        imgSubfolder: 'students',
        question: 'From which house is this student?',
        urlAdress: 'https://hp-api.onrender.com/api/characters',
        filterKey: 'hogwartsStudent',
        filterValue: true,
        ids: 28,
        answerProperty: 'house'
    }
};
const $e463bdc3eb55f472$export$3fc28146537f1a7e = {
    students_medium: [
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        }
    ],
    students_hard: [
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        }
    ],
    staff_medium: [
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        }
    ],
    staff_hard: [
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        }
    ],
    houses_medium: [
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        }
    ],
    houses_hard: [
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        },
        {
            name: 'unranked',
            result: '0'
        }
    ]
};
const $e463bdc3eb55f472$export$52edf5adb416f386 = [
    'Gryffindor',
    'Slytherin',
    'Hufflepuff',
    'Ravenclaw'
];
const $e463bdc3eb55f472$export$199f79993cf9c6ae = 'Harry Potter Quiz Game';
const $e463bdc3eb55f472$export$14409bccc772bf0b = {
    easy: {
        time: null,
        level: 'easy'
    },
    medium: {
        time: 0.25,
        level: 'medium'
    },
    hard: {
        time: 0.16667,
        level: 'hard'
    }
};
const $e463bdc3eb55f472$export$ab7b2e8261e630b8 = 'medium';
const $e463bdc3eb55f472$export$6554e0e4e82f1b3a = $e463bdc3eb55f472$export$d155b7b3d8e33c99.students.urlAdress;
const $e463bdc3eb55f472$export$44cafc266fd1f440 = './characters-mock.json';
const $e463bdc3eb55f472$export$d5f7d7e617fba3f9 = 1000;
const $e463bdc3eb55f472$export$4bf25cfb2848177c = 60;
const $e463bdc3eb55f472$export$f926102d6698a8aa = 10;
const $e463bdc3eb55f472$export$e089b3c2861d2024 = 0.5; // in minutes



class $eb4724066a2c0529$var$LocalStorageService {
    constructor(){}
    static saveRankings(rankings) {
        localStorage.setItem('rankings', JSON.stringify(rankings));
        return rankings;
    }
    static loadRankings() {
        return JSON.parse(localStorage.getItem('rankings')) || this.saveRankings((0, $e463bdc3eb55f472$export$3fc28146537f1a7e));
    }
}
var $eb4724066a2c0529$export$2e2bcd8739ae039 = $eb4724066a2c0529$var$LocalStorageService;


class $8a30481dfb98ee5c$var$Model {
    constructor(){
        this.gameMode = '';
        this.difficultyLevel = (0, $e463bdc3eb55f472$export$ab7b2e8261e630b8);
        this.rankings = (0, $eb4724066a2c0529$export$2e2bcd8739ae039).loadRankings();
        this.localStorageService = (0, $eb4724066a2c0529$export$2e2bcd8739ae039);
        this.gameMaker = undefined;
    }
}
var $8a30481dfb98ee5c$export$2e2bcd8739ae039 = $8a30481dfb98ee5c$var$Model;


function $9ad374e7fe581501$var$elementInjector(parentElement, children) {
    children.forEach((child)=>{
        if (typeof child === 'string') parentElement.appendChild(document.createTextNode(child));
        else parentElement.appendChild(child);
    });
}
var $9ad374e7fe581501$export$2e2bcd8739ae039 = $9ad374e7fe581501$var$elementInjector;



function $cefd4bb9a57192a5$var$elementCreator(type, attributes = {}, ...children) {
    const newElement = document.createElement(type);
    Object.entries(attributes).forEach(([key, value])=>{
        newElement.setAttribute(key, value);
    });
    (0, $9ad374e7fe581501$export$2e2bcd8739ae039)(newElement, children);
    return newElement;
}
var $cefd4bb9a57192a5$export$2e2bcd8739ae039 = $cefd4bb9a57192a5$var$elementCreator;


const $61efa832c1964c38$var$questionForMode = (mode)=>{
    const questions = {
        students: "Who is this Hogwart's student?",
        staff: "Who is this from Hogwart's staff?",
        houses: 'To which house do they belong\n?'
    };
    return (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        style: 'font-weight: 500'
    }, `MODE: ${questions[mode]}`);
};
var $61efa832c1964c38$export$2e2bcd8739ae039 = $61efa832c1964c38$var$questionForMode;



const $650f94836bffb880$var$imageNode = {};
const $650f94836bffb880$var$updateImage = (imageSource)=>{
    // Checking that img source is in base64 format or valid image URL
    const base64Reg = /^data:image\/(?:gif|png|jpeg|bmp|webp)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/;
    const imageUrlReg = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
    if (base64Reg.test(imageSource) || imageUrlReg.test(imageSource) || imageSource.startsWith('http')) $650f94836bffb880$var$imageNode.ref.setAttribute('src', imageSource);
    else throw new Error('Ups, format of input string is incorrect');
};
function $650f94836bffb880$var$displayImage(imageSource, altDescription) {
    const image = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('img', {
        class: 'game-image__content-image modal-img-node',
        alt: `${altDescription}`
    });
    $650f94836bffb880$var$imageNode.ref = image;
    $650f94836bffb880$var$updateImage(imageSource);
    return image;
}
var $650f94836bffb880$export$2e2bcd8739ae039 = $650f94836bffb880$var$displayImage;



const $ed12d6b632c7e351$var$modeButtons = [
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'button'
    }, 'Students'),
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'button'
    }, 'Houses'),
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'button'
    }, 'Staff')
];
var $ed12d6b632c7e351$export$2e2bcd8739ae039 = $ed12d6b632c7e351$var$modeButtons;



var $83b01bdf5c2c6e29$exports = {};
$83b01bdf5c2c6e29$exports = import.meta.resolve("hdvin");


const $b6f6956d2cf6c00e$var$createLogo = ()=>{
    const logo = new URL($83b01bdf5c2c6e29$exports);
    const img = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('img', {
        src: logo.href,
        class: 'header__game-img'
    });
    return img;
};
var $b6f6956d2cf6c00e$export$2e2bcd8739ae039 = $b6f6956d2cf6c00e$var$createLogo;






function $7a4038478dd4168b$var$modalTable(gameData) {
    function getAnswersRows() {
        const gameDetails = gameData.detailQuestionData;
        const answersRows = [];
        for(let i = 0; i < gameDetails.length; i++){
            const element = gameDetails[i];
            const name = element.playerAnswer;
            const { answer: answer } = element;
            const imageBase = element.imageBase64;
            const imageCell = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
                class: 'details__td'
            }, (0, $650f94836bffb880$export$2e2bcd8739ae039)(imageBase, 'very handsome someone'));
            const playerAnswer = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
                class: 'details__td'
            }, name);
            const correctAnswer = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
                class: 'details__td'
            }, answer);
            const newRow = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('tr', {
                class: 'details__tr'
            }, imageCell, playerAnswer, correctAnswer);
            answersRows.push(newRow);
        }
        return answersRows;
    }
    const table = getAnswersRows(gameData);
    const tableBody = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('tbody', {}, ...table);
    // table headeer
    const tableHeaders = [
        'Picture',
        'Your answer',
        'Answer'
    ];
    const tableHeadersElements = tableHeaders.map((header)=>{
        const tableHeader = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('th', {
            class: 'details__th'
        }, header);
        return tableHeader;
    });
    const tableHeadRow = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('tr', {
        class: 'details__thead'
    }, ...tableHeadersElements);
    const tableHead = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('thead', {}, tableHeadRow);
    const newTable = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('table', {
        class: 'details__table'
    }, tableHead, tableBody);
    return newTable;
}
var $7a4038478dd4168b$export$2e2bcd8739ae039 = $7a4038478dd4168b$var$modalTable;


function $8cd38d4bb9e4cfe0$var$modalDetails(gameData) {
    const detailsHeader = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'modal__text'
    }, 'Game details');
    const modalTab = (0, $7a4038478dd4168b$export$2e2bcd8739ae039)(gameData);
    const detailsContainer = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'details'
    }, detailsHeader, modalTab);
    return detailsContainer;
}
var $8cd38d4bb9e4cfe0$export$2e2bcd8739ae039 = $8cd38d4bb9e4cfe0$var$modalDetails;



function $0538045e18d6ae09$var$modalForm() {
    const modalInput = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('input', {
        class: 'modal__input',
        placeholder: 'your nickname',
        type: 'text',
        name: 'name',
        id: 'playerName',
        required: null
    }, 'Input');
    const playerFormLabel = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('label', {
        class: 'modal__label',
        for: 'name'
    }, 'Please fill your name to bring glory to your house!');
    const modalButton = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button-modalBtn'
    }, 'Save result and return!');
    const modalFormBuilder = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'modal__builder'
    }, modalInput, modalButton);
    const modalFormConstructor = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'modal__form'
    }, playerFormLabel, modalFormBuilder);
    return modalFormConstructor;
}
var $0538045e18d6ae09$export$2e2bcd8739ae039 = $0538045e18d6ae09$var$modalForm;


function $9f376d4a7fc821ab$var$ModalWindow(gameData) {
    // parametry//
    const modalHeader = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('h2', {
        class: 'modal__header'
    }, 'Game Over');
    const modalText = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: 'modal__text'
    }, $9f376d4a7fc821ab$var$chooseText(gameData));
    // DETAILS SECTION
    const detailsContainer = (0, $8cd38d4bb9e4cfe0$export$2e2bcd8739ae039)(gameData);
    // FORMS SECTION
    const modalFormContainer = (0, $0538045e18d6ae09$export$2e2bcd8739ae039)();
    // modalContainer construction //
    const modalContainer = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'modal__container'
    }, modalHeader, modalText, detailsContainer, modalFormContainer);
    const modal = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'modal'
    }, modalContainer);
    return modal;
}
function $9f376d4a7fc821ab$var$chooseText(gameData) {
    const playerPoints = gameData.correctAnswerScore;
    const questions = gameData.askedQuestions;
    let text = '';
    switch(true){
        case playerPoints < -10:
            text = `Your result: ${playerPoints} / ${questions}. 
"Honestly, if you were any slower, you'd be going backward." \u{2014} Draco Malfoy`;
            break;
        case playerPoints >= -10 && playerPoints < 1:
            text = `Your result: ${playerPoints} / ${questions}. 
"I hope you're pleased with yourselves. We could all have been killed \u{2014} or worse, expelled. Now if you don't mind, I'm going to bed." \u{2015} Hermione Granger`;
            break;
        case playerPoints >= 1 && playerPoints < 11:
            text = `Your result: ${playerPoints} / ${questions}. 
"When in doubt, go to the library." \u{2014} Ron Weasley " `;
            break;
        case playerPoints >= 11:
            text = `Your result: ${playerPoints} / ${questions}. 
"You're a little scary sometimes, you know that? Brilliant ... but scary." \u{2014} Ron Weasley`;
            break;
        default:
            text = `This is magic! You've got ${playerPoints}/${questions}  questions! Congratulations!`;
            break;
    }
    return text;
}
var $9f376d4a7fc821ab$export$2e2bcd8739ae039 = $9f376d4a7fc821ab$var$ModalWindow;




const $155688c1bba146e4$var$rulesTextBoiler = 'You have limited time to answer as many questions, as possible. During the game, on each question you need to select';
const $155688c1bba146e4$var$modeRules = (mode)=>{
    const rulesTextPart = {
        students: "the name of Hogwart's student",
        staff: "the name of Hogwart's staff member",
        houses: "a Hogwart's house of the character"
    };
    const rulesIcon = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('span', {
        class: 'rules-icon fas fa-graduation-cap'
    });
    const rulesHeader = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('h2', {
        class: 'game__mode-rules-header'
    }, rulesIcon, 'Mode Rules');
    const rulesText = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: 'game__mode-rules-text'
    }, `${$155688c1bba146e4$var$rulesTextBoiler} ${rulesTextPart[mode]} from available options.`);
    const rulesFullElement = [
        rulesHeader,
        rulesText
    ];
    return rulesFullElement;
};
var $155688c1bba146e4$export$2e2bcd8739ae039 = $155688c1bba146e4$var$modeRules;



function $6f7ec4134c6efe67$var$buttonPlay(text) {
    const buttonCreator = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button--orange'
    }, text);
    return buttonCreator;
}
var $6f7ec4134c6efe67$export$2e2bcd8739ae039 = $6f7ec4134c6efe67$var$buttonPlay;



var $09cd06161555c70f$exports = {};
$09cd06161555c70f$exports = import.meta.resolve("47oLX");


function $ebca3014a60e99bc$var$createImage() {
    const harryPotterImg = new URL($09cd06161555c70f$exports);
    const image = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('img', {
        src: harryPotterImg.href,
        class: 'game-image__content-image',
        alt: 'very handsome Harry'
    });
    return image;
}
var $ebca3014a60e99bc$export$2e2bcd8739ae039 = $ebca3014a60e99bc$var$createImage;



function $f8952040e89b452d$var$doBtnHallOfFame(text) {
    const imageCup = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('span', {
        class: 'game__button-icon fas fa-trophy'
    });
    const hofButton = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button--hof'
    }, imageCup, text);
    return hofButton;
}
var $f8952040e89b452d$export$2e2bcd8739ae039 = $f8952040e89b452d$var$doBtnHallOfFame;





// const _ranking = app.model.localStorageService.loadRankings();
// const hofData = LocalStorageService.loadRankings();
/* const arrStudents = [
  hofData.students_easy,
  hofData.students_medium,
  hofData.students_hard,
];
const arrHouses = [
  hofData.houses_easy,
  hofData.houses_medium,
  hofData.houses_hard,
];
const arrStaff = [hofData.staff_easy, hofData.staff_medium, hofData.staff_hard]; */ function $67c5a23716044fb4$var$getHofData(mode, level, place, property) {
    const hofData = (0, $eb4724066a2c0529$export$2e2bcd8739ae039).loadRankings();
    const arrStudents = [
        hofData.students_easy,
        hofData.students_medium,
        hofData.students_hard
    ];
    const arrHouses = [
        hofData.houses_easy,
        hofData.houses_medium,
        hofData.houses_hard
    ];
    const arrStaff = [
        hofData.staff_easy,
        hofData.staff_medium,
        hofData.staff_hard
    ];
    const _mode = mode.toLowerCase();
    const _level = level.toLowerCase();
    let selectedLevel;
    if (_level === 'easy') selectedLevel = 0;
    else if (_level === 'medium') selectedLevel = 1;
    else if (_level === 'hard') selectedLevel = 2;
    else throw Error('Wrong level data');
    let selectedMode;
    if (_mode === 'staff') selectedMode = arrStaff;
    else if (_mode === 'students') selectedMode = arrStudents;
    else if (_mode === 'houses') selectedMode = arrHouses;
    else throw Error('Wrong mode data');
    let selectedPlace;
    if (place === '1') selectedPlace = 0;
    else if (place === '2') selectedPlace = 1;
    else if (place === '3') selectedPlace = 2;
    else throw Error('Wrong place data');
    if (!selectedLevel || selectedMode[selectedLevel].length < selectedPlace) ;
    else return selectedMode[selectedLevel][selectedPlace][property];
}
var $67c5a23716044fb4$export$2e2bcd8739ae039 = $67c5a23716044fb4$var$getHofData;


function $5c713b415e09d080$var$hofTable(mode, level) {
    if (level === 'easy') {
        const altText = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
            class: 'hof__table-alttxt'
        }, 'Easy mode has no ranking available!!!');
        return altText;
    }
    const tableHead1 = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-header'
    }, 'Place');
    const tableHead2 = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-header'
    }, 'Player');
    const tableHead3 = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-header'
    }, 'Points');
    const tableRow1stPlace = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('tr', {}, (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-place'
    }, '1'), (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-player1'
    }, `${$5c713b415e09d080$var$getPlayerNameOrDefaultName(mode, level, '1')}`), (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-answered1'
    }, `${(0, $67c5a23716044fb4$export$2e2bcd8739ae039)(mode, level, '1', 'result')}`));
    const tableRow2ndPlace = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('tr', {}, (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-place'
    }, '2'), (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-player2'
    }, `${$5c713b415e09d080$var$getPlayerNameOrDefaultName(mode, level, '2')}`), (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-answered2'
    }, `${(0, $67c5a23716044fb4$export$2e2bcd8739ae039)(mode, level, '2', 'result')}`));
    const tableRow3rdPlace = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('tr', {}, (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-place'
    }, '3'), (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-player3'
    }, `${$5c713b415e09d080$var$getPlayerNameOrDefaultName(mode, level, '3')}`), (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('td', {
        class: 'hof__table-answered3'
    }, `${(0, $67c5a23716044fb4$export$2e2bcd8739ae039)(mode, level, '3', 'result')}`));
    const wholeTable = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('table', {
        class: 'hof__table'
    }, tableHead1, tableHead2, tableHead3, tableRow1stPlace, tableRow2ndPlace, tableRow3rdPlace);
    return wholeTable;
}
function $5c713b415e09d080$var$getPlayerNameOrDefaultName(mode, level, place) {
    if ((0, $67c5a23716044fb4$export$2e2bcd8739ae039)(mode, level, place, 'name') === '') return 'Noname Muggle';
    return (0, $67c5a23716044fb4$export$2e2bcd8739ae039)(mode, level, place, 'name');
}
var $5c713b415e09d080$export$2e2bcd8739ae039 = $5c713b415e09d080$var$hofTable;


const $cb7f4b7d503711d8$var$doHallOfFameContent = (mode, level)=>{
    const cupIcon = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('span', {
        class: 'rules-icon fas fa-trophy'
    });
    const hofHeader = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('h2', {
        class: 'game__mode-rules-header'
    }, cupIcon, ` ${mode} Mode Ranking - Level ${level}`);
    const hofFullElement = [
        hofHeader,
        (0, $5c713b415e09d080$export$2e2bcd8739ae039)(mode, level)
    ];
    return hofFullElement;
};
var $cb7f4b7d503711d8$export$2e2bcd8739ae039 = $cb7f4b7d503711d8$var$doHallOfFameContent;



function $3278f51224c5ee03$var$displayTimerText(timeInSeconds) {
    const min = Math.floor(timeInSeconds / 60);
    const sec = timeInSeconds % 60;
    const timer = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: 'game-timer__text'
    });
    if (timeInSeconds <= 20) timer.style.color = '#E23336';
    if (timeInSeconds < 10 || timeInSeconds % 60 === 0) timer.innerText = `Time Left: ${min}m 0${sec}s`;
    else timer.innerText = `Time Left: ${min}m ${sec}s`;
    return timer;
}
var $3278f51224c5ee03$export$2e2bcd8739ae039 = $3278f51224c5ee03$var$displayTimerText;



function $a4c25884755114bd$export$2e2bcd8739ae039(text) {
    const rulesIcon = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('span', {
        class: 'game__button-icon fas fa-graduation-cap'
    });
    const buttonCreator = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button-rules'
    }, rulesIcon, text);
    return buttonCreator;
}



const $70036952f27bae10$var$levelButtons = [
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button-lvlSettings'
    }, 'Easy - unlimited time / no points'),
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button-lvlSettings active'
    }, 'Medium - 15 seconds / good answer: 1 point / wrong answer: 0 points'),
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button-lvlSettings'
    }, 'Hard - 10 seconds / good answer: 1 point / wrong answer: -1 point')
];
var $70036952f27bae10$export$2e2bcd8739ae039 = $70036952f27bae10$var$levelButtons;



/**
 * At this moment our parameter for this function is question
 * @param question
 * question as an object with answers property (answers as array)
 * this function create buttons and return an array of buttons
 * @returns {*[]}
 */ function $709a9dac7d21ed33$var$answersButtons(question) {
    const buttons = [];
    question.answers.forEach((button, index)=>{
        buttons.push((0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
            class: 'game__mode-rules-answrBtn'
        }, question.answers[index]));
    });
    return buttons;
}
var $709a9dac7d21ed33$export$2e2bcd8739ae039 = $709a9dac7d21ed33$var$answersButtons;


function $99107e2c16a06181$var$clearActive(array) {
    array.map((item)=>item.classList.remove('active'));
}
var $99107e2c16a06181$export$2e2bcd8739ae039 = $99107e2c16a06181$var$clearActive;



function $c66f2c69876c2084$export$2e2bcd8739ae039() {
    const quitElem = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('i', {
        class: 'far fa-times-circle'
    });
    const quitElemText = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: '.quit-game-text'
    }, 'Quit Game');
    const quitGameButton = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'quit-game'
    }, quitElemText, quitElem);
    return quitGameButton;
}




var $d40ded06214b2d0f$exports = {};
$d40ded06214b2d0f$exports = import.meta.resolve("kcylu");


function $fb0ecdbff669e4ac$export$2e2bcd8739ae039(timeLeft, _timeStart) {
    const timerWrapper = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'game-timer__text-wrapper'
    });
    // Add initial timer text
    const initialTimerText = (0, $3278f51224c5ee03$export$2e2bcd8739ae039)(timeLeft);
    timerWrapper.appendChild(initialTimerText);
    const wandImg = new URL($d40ded06214b2d0f$exports);
    const image = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('img', {
        class: 'game-timer__image',
        src: wandImg.href,
        alt: 'The shaft of the wand'
    });
    const wandInner = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'game-timer__wand-inner'
    });
    const wand = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'game-timer__wand'
    }, wandInner);
    const wandWrapper = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('div', {
        class: 'game-timer__wand-wrapper'
    }, image, wand);
    const fullWand = [
        wandWrapper,
        timerWrapper
    ];
    // Use CSS animation for smooth progress
    if (timeLeft === 0) {
        wandInner.style.width = '0%';
        wandInner.style.animation = 'none';
    } else {
        // Set animation duration to remaining time
        wandInner.style.animationDuration = `${timeLeft}s`;
        wandInner.style.animationPlayState = 'running';
    }
    return fullWand;
}



const $2e555138f45cbf14$var$displayInitialMainText = [
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: 'game__mode-rules-text'
    }, "Lets find out if you are true wizard or regular  muggle! Test yourself and check if you know all  of the Hogwart\u2019s secrets."),
    (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: 'game__mode-rules-text'
    }, `Pick the game mode from main menu and answer all the question we prepared for you.`)
];
var $2e555138f45cbf14$export$2e2bcd8739ae039 = $2e555138f45cbf14$var$displayInitialMainText;



function $d9f0df0e614661f8$var$displayButtonSettings(text) {
    const createButtonSettings = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('button', {
        class: 'game__button game__button-settingsBtn'
    }, text);
    return createButtonSettings;
}
var $d9f0df0e614661f8$export$2e2bcd8739ae039 = $d9f0df0e614661f8$var$displayButtonSettings;



function $a6bda2336f639066$var$loadingScreen() {
    const loadingText = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('h2', {
        class: 'loading-screen__text'
    }, 'Get ready!');
    const loadingSubtext = (0, $cefd4bb9a57192a5$export$2e2bcd8739ae039)('p', {
        class: 'loading-screen__subtext'
    }, 'Loading your question...');
    return [
        loadingText,
        loadingSubtext
    ];
}
var $a6bda2336f639066$export$2e2bcd8739ae039 = $a6bda2336f639066$var$loadingScreen;


class $554bfdad8d522d5d$var$View {
    constructor(){
        this.toggleRulesHof = 'hall of fame';
        this.settings = false;
    }
    render(query, ...children) {
        if (children.length === 0 || !query) throw new Error('Required query and at least one child in arguments');
        const parentElem = document.querySelector(query);
        parentElem.innerHTML = '';
        if (!parentElem) throw new Error(`Not found element by query ${query}`);
        (0, $9ad374e7fe581501$export$2e2bcd8739ae039)(parentElem, children);
    }
    renderInitialScreen() {
        this.render('.header__game-logo', (0, $b6f6956d2cf6c00e$export$2e2bcd8739ae039)());
        this.render('.header__game-nav', ...(0, $ed12d6b632c7e351$export$2e2bcd8739ae039));
        this.render('.game__mode', (0, $e463bdc3eb55f472$export$199f79993cf9c6ae));
        this.render('.game__mode-rules', ...(0, $2e555138f45cbf14$export$2e2bcd8739ae039));
        this.render('.game-image__content', (0, $ebca3014a60e99bc$export$2e2bcd8739ae039)());
    }
    showViewsForChosenMode = (mode)=>{
        this.render('.game__mode', (0, $61efa832c1964c38$export$2e2bcd8739ae039)(mode));
        this.render('.game__mode-rules', ...(0, $155688c1bba146e4$export$2e2bcd8739ae039)(mode));
        this.render('.game__btns', (0, $f8952040e89b452d$export$2e2bcd8739ae039)(`Hall of fame`), (0, $6f7ec4134c6efe67$export$2e2bcd8739ae039)('Play the game'));
        const settingsButton = (0, $d9f0df0e614661f8$export$2e2bcd8739ae039)('settings');
        settingsButton.addEventListener('click', this.toggleSettingsView);
        this.render('.game-image__btns', settingsButton);
        this.settings = false;
    };
    showRulesButtons() {
        this.render('.game__btns', (0, $a4c25884755114bd$export$2e2bcd8739ae039)('rules'), (0, $6f7ec4134c6efe67$export$2e2bcd8739ae039)('Play the game'));
    }
    // Hof - Hall of Fame
    showHof = (gameMode, difficultyLevel)=>{
        this.render('.game__mode', 'HALL OF FAME');
        this.render('.game__mode-rules', ...(0, $cb7f4b7d503711d8$export$2e2bcd8739ae039)(gameMode, difficultyLevel));
        this.showRulesButtons();
    };
    showSettings() {
        this.render('.game__mode', 'Choose level');
        this.render('.game__mode-rules', ...(0, $70036952f27bae10$export$2e2bcd8739ae039));
        const settingsButton = (0, $d9f0df0e614661f8$export$2e2bcd8739ae039)('Save&back');
        settingsButton.addEventListener('click', this.toggleSettingsView);
        this.render('.game-image__btns', settingsButton);
        this.bindDifficultyLevelButton(window.app.changeDifficultyLevel);
    }
    hideSettings() {
        this.showViewsForChosenMode(window.app.model.gameMode);
        window.app.bindInitialHofAndPlay();
        this.toggleRulesHof = 'hall of fame';
    }
    toggleSettingsView = ()=>{
        if (!this.settings) {
            this.showSettings();
            this.settings = true;
        } else {
            this.hideSettings();
            this.settings = false;
        }
    };
    renderTimer(timeInSeconds, initialTime, isFirstRender = false) {
        if (isFirstRender) // Only render wand on first call
        this.render('.game-timer', ...(0, $fb0ecdbff669e4ac$export$2e2bcd8739ae039)(timeInSeconds, initialTime));
        else // Update only the timer text, not the wand
        this.render('.game-timer__text-wrapper', (0, $3278f51224c5ee03$export$2e2bcd8739ae039)(timeInSeconds));
    }
    renderModal(gameData) {
        this.render('.modal', (0, $9f376d4a7fc821ab$export$2e2bcd8739ae039)(gameData));
        const modal = document.querySelector('.modal');
        modal.classList.remove('modal__hidden');
    }
    // showModal() {}
    renderImage() {
        this.render('.game-image__content', (0, $650f94836bffb880$export$2e2bcd8739ae039)());
    }
    changeAnswrBtnBgColor(answer) {
        const posAnswrBtn = document.querySelectorAll('.game__mode-rules-answrBtn');
        if (answer === true) posAnswrBtn.forEach((el)=>el.classList.add('game__mode-rules-answrBtn-correct'));
        else posAnswrBtn.forEach((el)=>el.classList.add('game__mode-rules-answrBtn-false'));
    }
    renderQuitGame() {
        this.render('.header__game-nav', (0, $c66f2c69876c2084$export$2e2bcd8739ae039)());
    }
    renderLoadingScreen() {
        this.render('.game__mode', 'Get Ready!');
        this.render('.game__mode-rules', ...(0, $a6bda2336f639066$export$2e2bcd8739ae039)());
        // Keep the initial Harry image or clear it
        this.render('.game-image__content', (0, $ebca3014a60e99bc$export$2e2bcd8739ae039)());
    }
    renderQuestion(question, modeQuestion) {
        this.render('.game__mode', modeQuestion);
        this.render('.game__mode-rules', ...(0, $709a9dac7d21ed33$export$2e2bcd8739ae039)(question));
        this.render('.game-image__content', (0, $650f94836bffb880$export$2e2bcd8739ae039)(question.image, 'very handsome Harry'));
    }
    disappearButtonsAndBackground() {
        const playAndHofButtons = document.querySelector('.game__btns');
        // playAndHofButtons.classList.add('hidden-elements');
        playAndHofButtons.style.display = 'none';
        const settingsButton = document.querySelector('.game-image__btns');
        // settingsButton.classList.add('hidden-elements');
        settingsButton.style.display = 'none';
        const gameModeContainer = document.querySelector('.game__mode-rules');
        gameModeContainer.id = 'question-mode';
    }
    appearBackgroundAndButtons() {
        this.removeClassFromHtmlElement('.game__btns', 'hidden-elements');
        this.removeClassFromHtmlElement('.game-image__btns', 'hidden-elements');
        this.removeAttributeFromHtmlElement('.game__mode-rules', 'id');
    }
    changeCursorToCustom() {
        const customCursor = document.querySelector('.game');
        customCursor.classList.add('custom-cursor');
        const custCursor = document.querySelector('.header');
        custCursor.classList.add('custom-cursor');
    }
    changeGridSizes() {
        const changedGrid = document.querySelector('.game-wrapper');
        changedGrid.style.gridTemplateRows = '1fr 2fr 1fr';
    }
    changeNavStyles() {
        const changedNav = document.querySelector('.header__game-nav');
        changedNav.style.justifyContent = 'flex-end';
    }
    renderAfterQuitGame(level) {
        if (level !== (0, $e463bdc3eb55f472$export$14409bccc772bf0b).easy.level) {
            const timerWand = document.querySelector('.game-timer__wand-wrapper');
            timerWand.remove(timerWand);
            const timerText = document.querySelector('.game-timer__text');
            timerText.remove(timerText);
        }
        this.render('.header__game-nav', ...(0, $ed12d6b632c7e351$export$2e2bcd8739ae039));
        this.removeClassFromHtmlElement('.game', 'custom-cursor');
        this.removeClassFromHtmlElement('.header', 'custom-cursor');
        this.removeAttributeFromHtmlElement('.header__game-nav', 'style');
        this.removeAttributeFromHtmlElement('.game-wrapper', 'style');
        this.removeAttributeFromHtmlElement('.game__btns', 'style');
        this.removeAttributeFromHtmlElement('.game-image__btns', 'style');
        this.render('.game-image__content', (0, $ebca3014a60e99bc$export$2e2bcd8739ae039)());
    }
    removeAttributeFromHtmlElement(querySelector = '', attribute = '') {
        const element = document.querySelector(querySelector);
        element.removeAttribute(attribute);
    }
    removeClassFromHtmlElement(querySelector = '', classNameWithoutDot = '') {
        const element = document.querySelector(querySelector);
        element.classList.remove(classNameWithoutDot);
    }
    // -------------- BINDINGS ------------------------------------
    bindButtonPlay(handler) {
        const playButton = document.querySelector('.game__button--orange');
        playButton.addEventListener('click', ()=>{
            handler();
        });
    }
    bindModeButtons(handler) {
        (0, $ed12d6b632c7e351$export$2e2bcd8739ae039).map((button)=>button.addEventListener('click', ()=>{
                (0, $99107e2c16a06181$export$2e2bcd8739ae039)((0, $ed12d6b632c7e351$export$2e2bcd8739ae039));
                button.classList.add('active');
                handler(button.textContent.toLowerCase());
            }));
    }
    bindAnswerButtons(handler) {
        const answerButtons = [
            ...document.getElementsByClassName('game__mode-rules-answrBtn')
        ];
        answerButtons.map((button)=>button.addEventListener('click', ()=>{
                handler(button.textContent);
            }));
    }
    bindQuitGameButton(handler) {
        const quitButtonEvent = document.querySelector('.quit-game');
        quitButtonEvent.addEventListener('click', ()=>{
            handler();
        });
    }
    bindHofButton(handler) {
        const hofButton = document.querySelector('.game__button--hof');
        hofButton.addEventListener('click', ()=>{
            handler();
        });
    }
    bindRulesButton(handler) {
        const rulesButton = document.querySelector('.game__button-rules');
        rulesButton.addEventListener('click', ()=>{
            handler();
        });
    }
    // TODO: przeniesienie funkcji bindujących do controllera
    bindDifficultyLevelButton(handler) {
        (0, $70036952f27bae10$export$2e2bcd8739ae039).map((button, index)=>button.addEventListener('click', ()=>{
                (0, $99107e2c16a06181$export$2e2bcd8739ae039)((0, $70036952f27bae10$export$2e2bcd8739ae039));
                button.classList.add('active');
                handler(index);
            }));
    }
    bindModalButton(handler) {
        const modalButton = document.querySelector('.game__button-modalBtn');
        const modal = document.querySelector('.modal');
        modalButton.addEventListener('click', ()=>{
            handler(document.getElementById('playerName').value);
            modal.classList.add('modal__hidden');
            this.renderInitialScreen();
        });
    }
}
var $554bfdad8d522d5d$export$2e2bcd8739ae039 = $554bfdad8d522d5d$var$View;


/* eslint-disable import/extensions */ /* eslint-disable import/named */ /* eslint-disable import/extensions */ class $935b21b419628460$var$QuestionGenerator {
    static generateRandomId(amountOfId) {
        const minId = 0;
        return Math.floor(Math.random() * (amountOfId - minId + 1) + minId);
    }
    static generateQuestionsForCurrentMode(amountOfId) {
        const amountOfAnswersPerQuestion = 4;
        const generatedIds = [];
        if (amountOfId < amountOfAnswersPerQuestion || typeof amountOfId !== `number`) throw Error`Check amout of ID's and datatype. amountOfId must be greater or equal ${amountOfAnswersPerQuestion}. Passed value: ${amountOfId}, Type must be number. Passed type: ${typeof amountOfId}`;
        for(let index = 0; index < amountOfAnswersPerQuestion; index += 1){
            let id;
            do id = $935b21b419628460$var$QuestionGenerator.generateRandomId(amountOfId);
            while (generatedIds.includes(id) === true);
            generatedIds.push(id);
        }
        return generatedIds;
    }
    static chooseCorrectAnswer(arrayWithId = []) {
        arrayWithId.forEach((element)=>{
            if (typeof element !== 'number') throw Error`wrong datatype in array`;
        });
        if (arrayWithId.length !== 4) throw Error`4 elements needed. That array has ${arrayWithId.length} elements`;
        else {
            const minIndex = 0;
            const maxIndex = 3;
            const index = Math.floor(Math.random() * (maxIndex - minIndex + 1) + minIndex);
            const rightAnswer = arrayWithId[index];
            return rightAnswer;
        }
    }
}
var $935b21b419628460$export$2e2bcd8739ae039 = $935b21b419628460$var$QuestionGenerator;



class $11cbf8bba35c9b1d$var$DataManager {
    constructor(resourceAPIadress, idOfRightAnswer, answerProperty, imgSubfolder, IDsArray = [], filterKey = null, filterValue = null){
        this.idOfRightAnswer = idOfRightAnswer;
        this.resourceAPIadress = resourceAPIadress;
        this.answerProperty = answerProperty;
        this.imgSubfolder = imgSubfolder;
        this.IDsArray = IDsArray;
        this.filterKey = filterKey;
        this.filterValue = filterValue;
        this.arraywithHPObjects = [];
        this.rightAnswer = '';
        this.base64dataImg = '';
        this.arraywithAnswersForQuestion = [];
    }
    getDataForMode() {
        return this.arraywithHPObjects;
    }
    getDataForIDs(arraywithHPObjects) {
        let arrayWithAnswers = [];
        if (this.answerProperty === 'house') arrayWithAnswers = (0, $e463bdc3eb55f472$export$52edf5adb416f386);
        else this.IDsArray.forEach((element)=>{
            const obj = arraywithHPObjects[element];
            const { name: name } = obj;
            arrayWithAnswers.push(name);
        });
        return arrayWithAnswers;
    }
    async blobToBase64(blob) {
        return new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    async getDataForCorrectAnswer() {
        const obj = this.arraywithHPObjects[this.idOfRightAnswer];
        if (this.answerProperty === 'house') this.rightAnswer = obj.house;
        else this.rightAnswer = obj.name;
        // Use image URL from API if available, otherwise fallback to local
        if (obj.image && obj.image !== '') // Try to fetch and convert to base64
        try {
            const imgFromAPI = await fetch(obj.image);
            const imgBlob = await imgFromAPI.blob();
            this.base64dataImg = await this.blobToBase64(imgBlob);
        } catch (error) {
            console.warn('Failed to fetch image from API, using fallback:', error);
            // Fallback to local image
            const imgFromFile = await fetch(`./img/images/${this.imgSubfolder}/${this.idOfRightAnswer}.jpg`);
            const imgBlob = await imgFromFile.blob();
            this.base64dataImg = await this.blobToBase64(imgBlob);
        }
        else {
            // No image in API, use local
            const imgFromFile = await fetch(`./img/images/${this.imgSubfolder}/${this.idOfRightAnswer}.jpg`);
            const imgBlob = await imgFromFile.blob();
            this.base64dataImg = await this.blobToBase64(imgBlob);
        }
    }
    async getDataByAPI() {
        try {
            // Only fetch if we don't have data yet
            if (!this.arraywithHPObjects || this.arraywithHPObjects.length === 0) {
                let jsonData;
                try {
                    const response = await fetch(this.resourceAPIadress);
                    if (!response.ok) throw new Error(`API responded with status ${response.status}`);
                    jsonData = await response.json();
                } catch (apiError) {
                    console.warn('Failed to fetch from API, using mock data:', apiError);
                    // Fallback to mock data
                    const mockResponse = await fetch('./src/app/data/characters-mock.json');
                    jsonData = await mockResponse.json();
                }
                // Filter data if filterKey and filterValue are provided
                if (this.filterKey && this.filterValue !== null) {
                    this.arraywithHPObjects = jsonData.filter((character)=>character[this.filterKey] === this.filterValue && character.image && character.image !== '');
                    console.log(`Filtered ${this.arraywithHPObjects.length} characters with ${this.filterKey}=${this.filterValue}`);
                } else {
                    this.arraywithHPObjects = jsonData.filter((character)=>character.image && character.image !== '');
                    console.log(`Filtered ${this.arraywithHPObjects.length} characters with images`);
                }
            }
        } catch (error) {
            throw Error(`${error}`);
        }
    }
}
var $11cbf8bba35c9b1d$export$2e2bcd8739ae039 = $11cbf8bba35c9b1d$var$DataManager;



class $240f9ac516059147$var$MainQuestionManager {
    constructor(gameModesProperty){
        this.urlAdress = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[gameModesProperty].urlAdress;
        this.amountOfIDs = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[gameModesProperty].ids;
        this.answerProperty = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[gameModesProperty].answerProperty;
        this.imgSubfolder = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[gameModesProperty].imgSubfolder;
        this.filterKey = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[gameModesProperty].filterKey;
        this.filterValue = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[gameModesProperty].filterValue;
        this.arrayWithObjectsForMode = [];
        this.usedQuestionIndices = []; // Track already used questions
    }
    async getQuestion() {
        // First, get or filter the data
        const dataManager = new (0, $11cbf8bba35c9b1d$export$2e2bcd8739ae039)(this.urlAdress, 0, this.answerProperty, this.imgSubfolder, [], this.filterKey, this.filterValue);
        // Fetch and filter data if not already done
        if (this.arrayWithObjectsForMode.length === 0) {
            await dataManager.getDataByAPI();
            this.arrayWithObjectsForMode = dataManager.getDataForMode();
            console.log(`Loaded ${this.arrayWithObjectsForMode.length} characters for mode`);
        } else dataManager.arraywithHPObjects = this.arrayWithObjectsForMode;
        // Check if all questions have been used
        if (this.usedQuestionIndices.length >= this.arrayWithObjectsForMode.length) {
            console.log('All questions used! Game over.');
            return null; // No more questions available
        }
        // Get available indices (not yet used as main question)
        const availableIndices = [];
        for(let i = 0; i < this.arrayWithObjectsForMode.length; i++)if (!this.usedQuestionIndices.includes(i)) availableIndices.push(i);
        console.log(`Available questions: ${availableIndices.length}, Total: ${this.arrayWithObjectsForMode.length}`);
        // Pick a random question from available ones
        const randomIndex = Math.floor(Math.random() * availableIndices.length);
        const idOfCorrectAnswer = availableIndices[randomIndex];
        // Mark this question as used
        this.usedQuestionIndices.push(idOfCorrectAnswer);
        console.log(`Used ${this.usedQuestionIndices.length}/${this.arrayWithObjectsForMode.length} questions`);
        // Generate answer options - filter by gender of correct answer
        const correctCharacter = this.arrayWithObjectsForMode[idOfCorrectAnswer];
        const correctGender = correctCharacter.gender;
        // Get all characters with the same gender
        const sameGenderIndices = [];
        for(let i = 0; i < this.arrayWithObjectsForMode.length; i++)if (this.arrayWithObjectsForMode[i].gender === correctGender) sameGenderIndices.push(i);
        console.log(`Correct answer gender: ${correctGender}, available same gender: ${sameGenderIndices.length}`);
        // Generate 3 wrong answers with the same gender
        let arrayWithID = [
            idOfCorrectAnswer
        ]; // Start with correct answer
        if (sameGenderIndices.length >= 4) {
            // We have enough same-gender characters, pick 3 random wrong ones
            const wrongAnswers = [];
            while(wrongAnswers.length < 3){
                const randomIndex = Math.floor(Math.random() * sameGenderIndices.length);
                const candidateId = sameGenderIndices[randomIndex];
                if (candidateId !== idOfCorrectAnswer && !wrongAnswers.includes(candidateId)) wrongAnswers.push(candidateId);
            }
            arrayWithID.push(...wrongAnswers);
        } else {
            // Not enough same-gender characters, use all available characters
            console.warn(`Not enough same-gender characters (${sameGenderIndices.length}), using all characters`);
            const actualAmount = this.arrayWithObjectsForMode.length - 1;
            arrayWithID = (0, $935b21b419628460$export$2e2bcd8739ae039).generateQuestionsForCurrentMode(actualAmount);
            // Make sure the correct answer is in the options
            if (!arrayWithID.includes(idOfCorrectAnswer)) {
                const replaceIndex = Math.floor(Math.random() * arrayWithID.length);
                arrayWithID[replaceIndex] = idOfCorrectAnswer;
            }
        }
        // Shuffle the array so correct answer is not always first
        for(let i = arrayWithID.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [arrayWithID[i], arrayWithID[j]] = [
                arrayWithID[j],
                arrayWithID[i]
            ];
        }
        // Update dataManager with correct IDs
        dataManager.idOfRightAnswer = idOfCorrectAnswer;
        dataManager.IDsArray = arrayWithID;
        // Get answers and image
        dataManager.arraywithAnswersForQuestion = dataManager.getDataForIDs(dataManager.arraywithHPObjects);
        await dataManager.getDataForCorrectAnswer();
        const { arraywithAnswersForQuestion: arraywithAnswersForQuestion, rightAnswer: rightAnswer, base64dataImg: base64dataImg } = dataManager;
        const question = {
            image: base64dataImg,
            answers: arraywithAnswersForQuestion,
            rightAnswer: rightAnswer
        };
        return question;
    }
    getObjectsForMode() {
        if (this.arrayWithObjectsForMode.length > 0) return this.arrayWithObjectsForMode;
        throw Error('arrayWithObjectsForMode is empty, lets start the game for the first time');
    }
}
var $240f9ac516059147$export$2e2bcd8739ae039 = $240f9ac516059147$var$MainQuestionManager;


// eslint-disable-next-line import/extensions


function $c6955bf0ace091e4$export$76516b9df4db4980(correctAnswersScore, isAnswerCorrect, difficultyLevelsProperty) {
    let newScore;
    const isMediumMode = difficultyLevelsProperty === (0, $e463bdc3eb55f472$export$14409bccc772bf0b).medium.level;
    const isHardMode = difficultyLevelsProperty === (0, $e463bdc3eb55f472$export$14409bccc772bf0b).hard.level;
    if (!isMediumMode && !isHardMode) throw new Error('wrong difficulty level property or calculatingPoints value');
    if (isMediumMode) newScore = isAnswerCorrect ? correctAnswersScore + 1 : correctAnswersScore;
    if (isHardMode) newScore = isAnswerCorrect ? correctAnswersScore + 1 : correctAnswersScore - 1;
    return newScore;
}
var $c6955bf0ace091e4$export$2e2bcd8739ae039 = $c6955bf0ace091e4$export$76516b9df4db4980;


class $b9c386ae281d17ac$export$2616165974278734 {
    constructor(){
        this.correctAnswersScore = 0;
        this.detailQuestionData = [];
    }
    checkAndRegisterAnswer(imageBase64, playerAnswer, correctAnswer, difficultyLevelsProperty) {
        if (!playerAnswer) throw new Error('error with given argument: playerAnswer, the value is incorrect, it should be string');
        const isAnswerCorrect = playerAnswer === correctAnswer;
        if (difficultyLevelsProperty !== (0, $e463bdc3eb55f472$export$14409bccc772bf0b).easy.level) {
            this.correctAnswersScore = (0, $c6955bf0ace091e4$export$76516b9df4db4980)(this.correctAnswersScore, isAnswerCorrect, difficultyLevelsProperty);
            this.registerAnswer(imageBase64, correctAnswer, playerAnswer, isAnswerCorrect);
        }
        return isAnswerCorrect;
    }
    registerAnswer(imageBase64, correctAnswer, playerAnswer, isAnswerCorrect) {
        this.detailQuestionData.push({
            imageBase64: imageBase64,
            playerAnswer: playerAnswer,
            isAnswerCorrect: isAnswerCorrect,
            answer: correctAnswer
        });
    }
    clearGameData() {
        this.correctAnswersScore = 0;
        this.detailQuestionData.length = 0;
    }
    getPlayerEndGameData() {
        return {
            correctAnswersScore: this.correctAnswersScore,
            detailQuestionData: this.detailQuestionData
        };
    }
}
var $b9c386ae281d17ac$export$2e2bcd8739ae039 = $b9c386ae281d17ac$export$2616165974278734;


// eslint-disable-next-line import/extensions

class $4afea06ae5dd9a42$var$GameTimer {
    constructor(gameTime){
        this.gameTime = gameTime;
        this.stopGame = false;
        this.timer = null; // Store timer reference
    }
    setGameTime(newGameTime) {
        this.gameTime = newGameTime;
    }
    runTimer(callbackOnInterval, callbackOnEndOfTime) {
        // Clear any existing timer first
        if (this.timer) {
            console.log('Clearing existing timer');
            clearInterval(this.timer);
            this.timer = null;
        }
        this.stopGame = false;
        const initialTimeInMilisec = this.gameTime * (0, $e463bdc3eb55f472$export$4bf25cfb2848177c) * (0, $e463bdc3eb55f472$export$d5f7d7e617fba3f9);
        const totalTimeInSec = this.gameTime * (0, $e463bdc3eb55f472$export$4bf25cfb2848177c);
        const timeInterval = (0, $e463bdc3eb55f472$export$d5f7d7e617fba3f9);
        let timeLeft = initialTimeInMilisec;
        // Call immediately to render wand at start
        callbackOnInterval(timeLeft / (0, $e463bdc3eb55f472$export$d5f7d7e617fba3f9), totalTimeInSec);
        this.timer = setInterval(()=>{
            if (this.stopGame === true) {
                clearInterval(this.timer);
                this.timer = null;
                timeLeft = initialTimeInMilisec;
            } else if (timeLeft <= 0) {
                clearInterval(this.timer);
                this.timer = null;
                timeLeft = initialTimeInMilisec;
                callbackOnEndOfTime();
            } else {
                timeLeft -= timeInterval;
                const timeLeftInSec = timeLeft / (0, $e463bdc3eb55f472$export$d5f7d7e617fba3f9);
                callbackOnInterval(timeLeftInSec, totalTimeInSec);
            }
        }, timeInterval);
    }
}
var $4afea06ae5dd9a42$export$2e2bcd8739ae039 = $4afea06ae5dd9a42$var$GameTimer;



class $17e5bfd5df045fcb$var$GameMaker {
    constructor(gameModesProperty, difficultyLevelsProperty){
        this.mainQuestionManager = new (0, $240f9ac516059147$export$2e2bcd8739ae039)(gameModesProperty);
        this.difficultyLevelsProperty = difficultyLevelsProperty;
        this.timer = new (0, $4afea06ae5dd9a42$export$2e2bcd8739ae039)((0, $e463bdc3eb55f472$export$e089b3c2861d2024));
        this.player = new (0, $b9c386ae281d17ac$export$2616165974278734)();
        this.initialGameTimeMinutes = 2;
        this.objectsForMode = [];
        this.questionObject = {};
    }
    async createQuestion() {
        this.questionObject = await this.mainQuestionManager.getQuestion();
        if (this.objectsForMode.length === 0) this.objectsForMode = this.mainQuestionManager.arrayWithObjectsForMode;
        return this.questionObject;
    }
    createPlayerAndRunTimer(callbackOnInterval, callbackOnEndOfTime) {
        this.player = new (0, $b9c386ae281d17ac$export$2616165974278734)();
        // Stop existing timer if any
        if (this.timer) {
            console.log('Stopping existing timer before creating new one');
            this.timer.stopGame = true;
        }
        if ((0, $e463bdc3eb55f472$export$14409bccc772bf0b)[this.difficultyLevelsProperty].time !== null) {
            this.timer = new (0, $4afea06ae5dd9a42$export$2e2bcd8739ae039)((0, $e463bdc3eb55f472$export$14409bccc772bf0b)[this.difficultyLevelsProperty].time);
            this.timer.runTimer(callbackOnInterval, callbackOnEndOfTime);
        }
    }
    checkAndRegisterAnswer(answer) {
        const isAnswerCorrect = this.player.checkAndRegisterAnswer(this.questionObject.image, answer, this.questionObject.rightAnswer, this.difficultyLevelsProperty);
        return isAnswerCorrect;
    }
    getEndGameData() {
        const playerQuestionData = this.player.getPlayerEndGameData();
        return {
            correctAnswerScore: playerQuestionData.correctAnswersScore,
            detailQuestionData: playerQuestionData.detailQuestionData,
            askedQuestions: playerQuestionData.detailQuestionData.length
        };
    }
    clearCurrentGameData() {
        this.player.clearGameData();
        this.timer.stopGame = true;
    }
}
var $17e5bfd5df045fcb$export$2e2bcd8739ae039 = $17e5bfd5df045fcb$var$GameMaker;



class $ea26d9b2ae1b9599$var$Controller {
    constructor(model, view){
        this.model = model;
        this.view = view;
        this.endGameData = {};
        // this.view.renderModal();
        this.view.renderInitialScreen();
        this.bindModeButtons();
    // TODO: przeniesienie bindowania Settings do controllera this.view.bindSettingsButton(this.view.toggleSettingsView);
    }
    doAtInterval = (timeInSeconds, initialTime)=>{
        // If wand was already rendered, always update only text (isFirstTimerRender = false)
        this.view.renderTimer(timeInSeconds, initialTime, false);
    };
    doAtEnd = ()=>{
        this.endGameData = this.model.gameMaker.getEndGameData();
        this.view.renderModal(this.endGameData);
        this.view.bindModalButton(this.saveName);
        this.view.appearBackgroundAndButtons();
        this.view.renderAfterQuitGame();
    };
    saveName = (name)=>{
        this.model.name = name;
        this.saveResult();
    };
    startGame = async ()=>{
        console.log('Starting game with mode:', this.model.gameMode, 'difficulty:', this.model.difficultyLevel);
        try {
            // Stop any existing game/timer first
            if (this.model.gameMaker) {
                console.log('Clearing previous game');
                this.model.gameMaker.clearCurrentGameData();
            }
            this.model.gameMaker = new (0, $17e5bfd5df045fcb$export$2e2bcd8739ae039)(this.model.gameMode, this.model.difficultyLevel);
            // Update UI immediately before loading question
            this.view.disappearButtonsAndBackground();
            this.view.renderQuitGame();
            this.view.bindQuitGameButton(this.doAfterQuitGame);
            this.view.changeCursorToCustom();
            this.view.changeGridSizes();
            this.view.changeNavStyles();
            // Show loading screen
            this.view.renderLoadingScreen();
            // Wait 1 second before starting the game
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            // Render wand immediately if there's a time limit
            const difficultyTime = (0, $e463bdc3eb55f472$export$14409bccc772bf0b)[this.model.difficultyLevel].time;
            if (difficultyTime !== null) {
                const initialTimeInSeconds = difficultyTime * 60;
                this.view.renderTimer(initialTimeInSeconds, initialTimeInSeconds, true);
            // Don't reset the flag yet - it will be used in the first callback
            }
            // Start timer
            this.model.gameMaker.createPlayerAndRunTimer(this.doAtInterval, this.doAtEnd);
            const closure = this;
            await closure.showQuestion();
        } catch (error) {
            console.error('Error starting game:', error);
            alert(`Failed to start game: ${error.message}`);
        }
    };
    doAfterQuitGame = ()=>{
        this.model.gameMaker.clearCurrentGameData();
        this.changeGameMode((0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[this.model.gameMode].gamemode.toLowerCase());
        this.view.appearBackgroundAndButtons();
        this.view.renderAfterQuitGame(this.model.difficultyLevel);
    };
    async showQuestion() {
        console.log('Showing question for mode:', this.model.gameMode);
        const { question: question } = (0, $e463bdc3eb55f472$export$d155b7b3d8e33c99)[this.model.gameMode.toLowerCase()];
        const questionData = await this.model.gameMaker.createQuestion();
        console.log('Question data:', questionData);
        // Check if there are no more questions
        if (questionData === null) {
            console.log('No more questions available, ending game');
            this.doAtEnd();
            return;
        }
        this.view.renderQuestion(questionData, question);
        const closure = this;
        this.view.bindAnswerButtons(async (answer)=>{
            const isAnswerCorrect = closure.model.gameMaker.checkAndRegisterAnswer(answer);
            this.view.changeAnswrBtnBgColor(isAnswerCorrect);
            await closure.showQuestion();
        });
    }
    changeGameMode = (mode)=>{
        const level = this.model.difficultyLevel;
        this.model.gameMode = mode.toLowerCase();
        if (this.view.toggleRulesHof === 'hall of fame') {
            this.view.showViewsForChosenMode(mode, level);
            this.bindInitialHofAndPlay();
        } else this.showHofView();
    };
    toggleRulesHof = ()=>{
        if (this.view.toggleRulesHof === 'hall of fame') {
            this.showHofView();
            this.view.toggleRulesHof = 'rules';
        } else if (this.view.toggleRulesHof === 'rules') {
            this.showRulesForChosenMode();
            this.view.toggleRulesHof = 'hall of fame';
        }
    };
    bindInitialHofAndPlay = ()=>{
        this.view.bindHofButton(this.toggleRulesHof);
        this.view.bindButtonPlay(this.startGame);
    };
    bindInitialRulesAndPlay = ()=>{
        this.view.bindRulesButton(this.toggleRulesHof);
        this.view.bindButtonPlay(this.startGame);
    };
    changeDifficultyLevel = (difficultyLevelIndex)=>{
        const levels = Object.keys((0, $e463bdc3eb55f472$export$14409bccc772bf0b));
        const level = levels[difficultyLevelIndex];
        this.model.difficultyLevel = (0, $e463bdc3eb55f472$export$14409bccc772bf0b)[level].level;
    };
    showSettingsScreen() {
        this.view.showSettings();
    }
    updateViewsForHallOfFameAtChosenMode(mode) {
        this.view.updateViewsForHallOfFameAtChosenMode(mode);
    }
    saveResult() {
        const { rankings: rankings, name: name, gameMode: gameMode, difficultyLevel: difficultyLevel } = this.model;
        const result = this.endGameData.correctAnswerScore;
        const mode = `${gameMode}_${difficultyLevel}`;
        rankings[mode].push({
            name: name,
            result: result
        });
        rankings[mode].sort((a, b)=>a.result < b.result ? 1 : -1);
        if (rankings[mode].length > 3) rankings[mode].pop();
        this.model.localStorageService.saveRankings(rankings);
    }
    showHofView = ()=>{
        this.view.showHof(this.model.gameMode, this.model.difficultyLevel);
        this.bindInitialRulesAndPlay();
    };
    showRulesForChosenMode = ()=>{
        this.view.showViewsForChosenMode(this.model.gameMode);
        this.view.bindModeButtons(this.changeGameMode);
        this.bindInitialHofAndPlay();
    };
    bindModeButtons = ()=>{
        this.view.bindModeButtons(this.changeGameMode);
    };
}
var $ea26d9b2ae1b9599$export$2e2bcd8739ae039 = $ea26d9b2ae1b9599$var$Controller;


// create new class instance for our model
const $51de5c021cdac42c$var$model = new (0, $8a30481dfb98ee5c$export$2e2bcd8739ae039)();
// create new class instance for our view
const $51de5c021cdac42c$var$view = new (0, $554bfdad8d522d5d$export$2e2bcd8739ae039)();
// create new class instance for our app
const $51de5c021cdac42c$var$app = new (0, $ea26d9b2ae1b9599$export$2e2bcd8739ae039)($51de5c021cdac42c$var$model, $51de5c021cdac42c$var$view);
// loading our site in webbrowser
window.onload = ()=>$51de5c021cdac42c$var$app;
// we can control from console our app
window.app = $51de5c021cdac42c$var$app;


//# sourceMappingURL=Project-I.1f1b4ad4.js.map
